import React from 'react';
import { Badge, Box, Flex, Heading, Text } from '@marvelapp/ui';
function SettingsItem(_a) {
    var actions = _a.actions, children = _a.children, description = _a.description, _b = _a.headingSize, headingSize = _b === void 0 ? 2 : _b, isBeta = _a.isBeta, _c = _a.maxWidth, maxWidth = _c === void 0 ? 500 : _c, mb = _a.mb, title = _a.title;
    return (React.createElement(Box, { borderBottom: "1px solid", borderColor: "smoke", mb: mb, py: 4 },
        React.createElement(Flex, null,
            React.createElement(Box, { flex: 1, pr: 3, py: 2 },
                React.createElement(Heading, { alignItems: "center", display: "flex", fontSize: headingSize, fontWeight: "500", htmlFor: 1, lineHeight: 1.3, tag: "label" },
                    title,
                    isBeta && (React.createElement(Badge, { fontSize: 0, fontWeight: 600, height: "16px", kind: "ghost", lineHeight: "16px", marginLeft: 2, minWidth: 26, paddingTop: "1px", px: "6px" }, "Beta"))),
                React.createElement(Text, { color: "slate", fontSize: 2, maxWidth: maxWidth, mt: 2 }, description)),
            React.createElement(Flex, { alignItems: "center" }, children)),
        actions));
}
export default SettingsItem;
